// Fonte MG: Ministério da Saúde — atualizado 18/12/2025
// Fonte RJ: Rio Com Saúde / SES-RJ — Centros de Referência Peçonhentos
// Seleção dos principais PESAs com soro ESCORPIÔNiCO confirmado

import { Hospital } from './hospitais-sp';

export const HOSPITAIS_MG: Hospital[] = [
  // === BELO HORIZONTE e RMBH ===
  {
    id: 101,
    nome: 'Hospital João XXIII — FHEMIG',
    endereco: 'Av. Alfredo Balena, 400 — Santa Efigênia',
    cidade: 'Belo Horizonte',
    regiao: 'Capital / RMBH',
    telefone: '(31) 3224-4000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -19.9245, lng: -43.9352,
    municipiosAtendidos: 'Referência estadual — toda a RMBH'
  },
  {
    id: 102,
    nome: 'Hospital Municipal José Lucas Filho',
    endereco: 'Av. João César de Oliveira, 4495 — Cinco',
    cidade: 'Contagem',
    regiao: 'RMBH',
    telefone: '(31) 3352-8827',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -19.9322, lng: -44.0534,
    municipiosAtendidos: 'Contagem e região oeste da RMBH'
  },
  {
    id: 103,
    nome: 'Hospital Público Regional Prefeito Osvaldo Franco',
    endereco: 'Av. Edmeia Matos Lazarotti, 3800 — Brasília',
    cidade: 'Betim',
    regiao: 'RMBH',
    telefone: '(31) 3539-8100',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -19.9680, lng: -44.1997,
    municipiosAtendidos: 'Betim e região'
  },
  // === TRIÂNGULO MINEIRO ===
  {
    id: 104,
    nome: 'Hospital de Clínicas — UFU',
    endereco: 'Av. Pará, 1720 — Umuarama',
    cidade: 'Uberlândia',
    regiao: 'Triângulo Mineiro',
    telefone: '(34) 3218-2000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.9060, lng: -48.2576,
    municipiosAtendidos: 'Referência para todo o Triângulo Mineiro'
  },
  {
    id: 105,
    nome: 'Pronto Socorro Municipal',
    endereco: 'Praça da Constituição, 142 — Centro',
    cidade: 'Araguari',
    regiao: 'Triângulo Mineiro',
    telefone: '(34) 3690-3017',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.6478, lng: -48.1886,
    municipiosAtendidos: 'Araguari e região'
  },
  {
    id: 106,
    nome: 'UPA — Unidade de Pronto Atendimento',
    endereco: 'Av. João Paulo II, 1900 — Vila Jardim',
    cidade: 'Araxá',
    regiao: 'Triângulo Mineiro',
    telefone: '(34) 3664-5805',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -19.5936, lng: -46.9405,
    municipiosAtendidos: 'Araxá e Alto Paranaíba'
  },
  {
    id: 107,
    nome: 'Hospital João Paulo II',
    endereco: 'Praça Dona Valdomira Neves de Ferreira, 112 — Centro',
    cidade: 'Araporã',
    regiao: 'Triângulo Mineiro',
    telefone: '(34) 3284-9551',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.4467, lng: -49.1886,
    municipiosAtendidos: 'Araporã e região norte do Triângulo'
  },
  // === ZONA DA MATA ===
  {
    id: 108,
    nome: 'Santa Casa de Misericórdia',
    endereco: 'Av. Cel. Antônio Augusto Souza Filho, 442 — Santa Teresa',
    cidade: 'Cataguases',
    regiao: 'Zona da Mata',
    telefone: '(32) 3429-4900',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -21.3878, lng: -42.6980,
    municipiosAtendidos: 'Cataguases e Zona da Mata sul'
  },
  {
    id: 109,
    nome: 'Hospital São Salvador',
    endereco: 'Rua Dr. Paulo Ladeira Fonseca, 1778',
    cidade: 'Além Paraíba',
    regiao: 'Zona da Mata',
    telefone: '(32) 3465-4366',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -21.8792, lng: -42.7000,
    municipiosAtendidos: 'Além Paraíba e fronteira com RJ'
  },
  // === SUL DE MINAS ===
  {
    id: 110,
    nome: 'Hospital Universitário Alzira Velano',
    endereco: 'Rua Geraldo Freitas Costa, 120 — Centro',
    cidade: 'Alfenas',
    regiao: 'Sul de Minas',
    telefone: '(35) 3299-3500',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -21.4289, lng: -45.9469,
    municipiosAtendidos: 'Alfenas e sul de Minas oeste'
  },
  {
    id: 111,
    nome: 'Santa Casa de Misericórdia de Andradas',
    endereco: 'Rua Capitão Cirilo, 668 — Alto Alegre',
    cidade: 'Andradas',
    regiao: 'Sul de Minas',
    telefone: '(35) 3731-1345',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -22.0644, lng: -46.5706,
    municipiosAtendidos: 'Andradas e sul de Minas próximo a SP'
  },
  {
    id: 112,
    nome: 'Hospital e Maternidade São Lucas de Extrema',
    endereco: 'R. Mauri Bueno de Andrade, 101 — Jardim São Cristóvão',
    cidade: 'Extrema',
    regiao: 'Sul de Minas',
    telefone: '(35) 3435-1333',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8562, lng: -46.3198,
    municipiosAtendidos: 'Extrema — fronteira MG/SP'
  },
  // === NORTE DE MINAS ===
  {
    id: 113,
    nome: 'Hospital Regional de Bocaiúva Dr. Gil Alves',
    endereco: 'Praça Zico Caldeira, 50 — Centro',
    cidade: 'Bocaiúva',
    regiao: 'Norte de Minas',
    telefone: '(38) 3251-6500',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -17.1097, lng: -43.8176,
    municipiosAtendidos: 'Bocaiúva e Norte de Minas'
  },
  {
    id: 114,
    nome: 'Hospital Senhora Santana',
    endereco: 'Av. Bias Fortes, s/n — Dona Joaquina',
    cidade: 'Brasília de Minas',
    regiao: 'Norte de Minas',
    telefone: '(38) 3231-1111',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -16.2071, lng: -44.4321,
    municipiosAtendidos: 'Brasília de Minas e Alto São Francisco'
  },
  // === VALE DO RIO DOCE ===
  {
    id: 115,
    nome: 'Hospital Municipal Governador Valadares',
    endereco: 'Rua Teófilo Otoni, 361 — Centro',
    cidade: 'Governador Valadares',
    regiao: 'Vale do Rio Doce',
    telefone: '(33) 3271-2578',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.8533, lng: -41.9494,
    municipiosAtendidos: 'Governador Valadares e Vale do Rio Doce'
  },
  {
    id: 116,
    nome: 'UPA — Caratinga',
    endereco: 'Rua Lamartine, 2 — Centro',
    cidade: 'Caratinga',
    regiao: 'Vale do Rio Doce',
    telefone: '(33) 3329-8016',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -19.7906, lng: -42.1381,
    municipiosAtendidos: 'Caratinga e Leste de MG'
  },
  // === CENTRO-OESTE DE MG ===
  {
    id: 117,
    nome: 'UPA Padre Roberto',
    endereco: 'Rua Nilo Maciel, 241 — Ponte Funda',
    cidade: 'Divinópolis',
    regiao: 'Centro-Oeste de MG',
    telefone: '(37) 3221-3707',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -20.1386, lng: -44.8875,
    municipiosAtendidos: 'Divinópolis e Centro-Oeste'
  },
  {
    id: 118,
    nome: 'Santa Casa de Misericórdia — Formiga',
    endereco: 'R. Dr. Teixeira Soares, 335 — Centro',
    cidade: 'Formiga',
    regiao: 'Centro-Oeste de MG',
    telefone: '(37) 3329-1300',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -20.4647, lng: -45.4264,
    municipiosAtendidos: 'Formiga e região'
  },
  // === CAMPOS DAS VERTENTES ===
  {
    id: 119,
    nome: 'Hospital Regional de Barbacena José Américo',
    endereco: 'Av. 14 de Agosto, s/n — Floresta',
    cidade: 'Barbacena',
    regiao: 'Campos das Vertentes',
    telefone: '(32) 3620-2630',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -21.2264, lng: -43.7731,
    municipiosAtendidos: 'Barbacena e Campos das Vertentes'
  },
  // === METALÚRGICA ===
  {
    id: 120,
    nome: 'Policlínica Pronto Atendimento',
    endereco: 'Av. Mario Rodrigues Pereira, 175 — Centro',
    cidade: 'Conselheiro Lafaiete',
    regiao: 'Metalúrgica',
    telefone: '(32) 3769-2654',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -20.6600, lng: -43.7883,
    municipiosAtendidos: 'Conselheiro Lafaiete e região metalúrgica'
  },
  // === CORONEL FABRICIANO / IPATINGA ===
  {
    id: 121,
    nome: 'UPA — Coronel Fabriciano',
    endereco: 'Av. Manaim, s/n — Silvio Pereira',
    cidade: 'Coronel Fabriciano',
    regiao: 'Vale do Aço',
    telefone: '(31) 3406-7585',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -19.5186, lng: -42.6269,
    municipiosAtendidos: 'Coronel Fabriciano, Ipatinga e Vale do Aço'
  },
  // === DIAMANTINA ===
  {
    id: 122,
    nome: 'Santa Casa de Caridade de Diamantina',
    endereco: 'Rua da Caridade, 106 — Centro',
    cidade: 'Diamantina',
    regiao: 'Jequitinhonha',
    telefone: '(38) 3532-1303',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.2394, lng: -43.6006,
    municipiosAtendidos: 'Diamantina e Vale do Jequitinhonha'
  },
  // === CURVELO ===
  {
    id: 123,
    nome: 'Pronto Socorro Municipal Dr. Márcio Carvalho Lopes Filho',
    endereco: 'Avenida Timbiras, 719',
    cidade: 'Curvelo',
    regiao: 'Central de Minas',
    telefone: '(38) 3729-1217',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -18.7556, lng: -44.4300,
    municipiosAtendidos: 'Curvelo e Central de Minas'
  },
];

export const HOSPITAIS_RJ: Hospital[] = [
  // === CAPITAL ===
  {
    id: 201,
    nome: 'Hospital Municipal Lourenço Jorge',
    endereco: 'Av. Ayrton Senna, 2000 — Barra da Tijuca',
    cidade: 'Rio de Janeiro',
    regiao: 'Zona Oeste / Capital',
    telefone: '(21) 3111-4766',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.9972, lng: -43.3656,
    municipiosAtendidos: 'Barra da Tijuca, Recreio, Jacarepaguá — plantão 24h'
  },
  {
    id: 202,
    nome: 'Hospital Evandro Chagas — Fiocruz',
    endereco: 'Av. Brasil, s/n — Manguinhos',
    cidade: 'Rio de Janeiro',
    regiao: 'Zona Norte / Capital',
    telefone: '(21) 3865-9595',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8687, lng: -43.2322,
    municipiosAtendidos: 'Zona Norte e Grande Rio — plantão fins de semana'
  },
  // === GRANDE RIO ===
  {
    id: 203,
    nome: 'Hospital Geral de Nova Iguaçu',
    endereco: 'Av. Henrique Duque Estrada Mayer, 953 — Posse',
    cidade: 'Nova Iguaçu',
    regiao: 'Baixada Fluminense',
    telefone: '(21) 3779-9900',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.7556, lng: -43.4511,
    municipiosAtendidos: 'Nova Iguaçu e Baixada Fluminense'
  },
  {
    id: 204,
    nome: 'Hospital Municipal de Magé',
    endereco: 'Rua Pio XII, 81 — Centro',
    cidade: 'Magé',
    regiao: 'Baixada Fluminense',
    telefone: '(21) 2633-6909',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.6536, lng: -43.0411,
    municipiosAtendidos: 'Magé e Guapimirim'
  },
  {
    id: 205,
    nome: 'Hospital Municipal de Cachoeiras de Macacu',
    endereco: 'R. Ary Parreira, 22 — Campo do Prado',
    cidade: 'Cachoeiras de Macacu',
    regiao: 'Serrana',
    telefone: '(21) 2649-2006',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.4631, lng: -42.6531,
    municipiosAtendidos: 'Cachoeiras de Macacu e região'
  },
  // === NITERÓI E REGIÃO DOS LAGOS ===
  {
    id: 206,
    nome: 'Hospital Universitário Antônio Pedro — UFF',
    endereco: 'R. Marquês de Paraná, 303 — Centro',
    cidade: 'Niterói',
    regiao: 'Niterói / Grande Rio',
    telefone: '(21) 2629-9145',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8967, lng: -43.1183,
    municipiosAtendidos: 'Niterói, São Gonçalo e Região Metropolitana leste'
  },
  {
    id: 207,
    nome: 'Associação Hospitalar Armando Vidal',
    endereco: 'R. Farias Serra, 79 — Centro',
    cidade: 'São Gonçalo',
    regiao: 'Grande Rio Leste',
    telefone: '(22) 2758-1060',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8267, lng: -43.0558,
    municipiosAtendidos: 'São Gonçalo'
  },
  {
    id: 208,
    nome: 'Hospital Municipal Dr. Fernando Pereira da Silva',
    endereco: 'Rodovia 168, Km 4 — Vargem Santa',
    cidade: 'Macaé',
    regiao: 'Norte Fluminense',
    telefone: '(22) 2773-0061',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.3708, lng: -41.7869,
    municipiosAtendidos: 'Macaé e Norte Fluminense'
  },
  {
    id: 209,
    nome: 'Hospital Ferreira Machado',
    endereco: 'R. Rocha Leão, 2',
    cidade: 'Campos dos Goytacazes',
    regiao: 'Norte Fluminense',
    telefone: '(22) 2737-2502',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -21.7610, lng: -41.3289,
    municipiosAtendidos: 'Campos dos Goytacazes e Norte Fluminense'
  },
  // === SERRANA ===
  {
    id: 210,
    nome: 'Hospital Municipal Raul Sertã',
    endereco: 'R. General Osório, 324 — Centro',
    cidade: 'Nova Friburgo',
    regiao: 'Serrana',
    telefone: '(22) 2523-9000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.2817, lng: -42.5311,
    municipiosAtendidos: 'Nova Friburgo e região serrana norte'
  },
  {
    id: 211,
    nome: 'Hospital Municipal Nelson de Sá Earp',
    endereco: 'R. Paulino Afonso, 455 — Centro',
    cidade: 'Petrópolis',
    regiao: 'Serrana',
    telefone: '(24) 2237-4062',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.5046, lng: -43.1803,
    municipiosAtendidos: 'Petrópolis e Serra Fluminense'
  },
  {
    id: 212,
    nome: 'Hospital de Clínicas Constantino Ottaviano',
    endereco: 'R. Delfim Moreira, 2211 — Vale Paraíso',
    cidade: 'Teresópolis',
    regiao: 'Serrana',
    telefone: '(21) 2741-4900',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.4122, lng: -42.9758,
    municipiosAtendidos: 'Teresópolis e Serra dos Órgãos'
  },
  // === COSTA VERDE / COSTA DO SOL ===
  {
    id: 213,
    nome: 'Hospital de Praia Brava / Pronto Socorro Municipal',
    endereco: 'Rod. Gov. Mário Covas BR-101 Km 524',
    cidade: 'Angra dos Reis',
    regiao: 'Costa Verde',
    telefone: '(24) 3362-1272',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.9676, lng: -44.3178,
    municipiosAtendidos: 'Angra dos Reis, Paraty e Costa Verde'
  },
  {
    id: 214,
    nome: 'Hospital Municipal de Paraty',
    endereco: 'Av. São Pedro de Alcântara, s/n — Pontal',
    cidade: 'Paraty',
    regiao: 'Costa Verde',
    telefone: '(24) 3371-3052',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.2194, lng: -44.7150,
    municipiosAtendidos: 'Paraty e litoral sul'
  },
  // === MÉDIO PARAÍBA ===
  {
    id: 215,
    nome: 'Hospital Municipal de Emergência Henrique Sérgio Gregori',
    endereco: 'Av. Marcílio Dias, 800 — Jardim Jalisco',
    cidade: 'Resende',
    regiao: 'Médio Paraíba',
    telefone: '(24) 3381-2053',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.4686, lng: -44.4508,
    municipiosAtendidos: 'Resende, Itatiaia e Sul Fluminense'
  },
  {
    id: 216,
    nome: 'Santa Casa de Misericórdia de Barra Mansa',
    endereco: 'R. Pinto Ribeiro, 205 — Centro',
    cidade: 'Barra Mansa',
    regiao: 'Médio Paraíba',
    telefone: '(24) 3325-8300',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.5431, lng: -44.1736,
    municipiosAtendidos: 'Barra Mansa, Volta Redonda e Médio Paraíba'
  },
  {
    id: 217,
    nome: 'Centro de Assistência Intermediária de Saúde (CAIS)',
    endereco: 'R. Gov. Luiz Monteiro Portela, 298 — Aterrado',
    cidade: 'Volta Redonda',
    regiao: 'Médio Paraíba',
    telefone: '(24) 3339-9566',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.5231, lng: -44.0964,
    municipiosAtendidos: 'Volta Redonda e região industrial'
  },
  // === VALE DO PARAÍBA FLUMINENSE ===
  {
    id: 218,
    nome: 'Hospital Universitário Sul Fluminense',
    endereco: 'R. Vicente Celestino, 201 — Madruga',
    cidade: 'Vassouras',
    regiao: 'Vale do Paraíba',
    telefone: '(24) 2471-8200',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.4036, lng: -43.6631,
    municipiosAtendidos: 'Vassouras e Vale do Paraíba fluminense'
  },
  {
    id: 219,
    nome: 'Hospital de Clínicas N. Sra. da Conceição / UPA 31',
    endereco: 'R. Maestro Costa Barros, 642 — Centro',
    cidade: 'Três Rios',
    regiao: 'Centro-Sul Fluminense',
    telefone: '(24) 2255-0600',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.1167, lng: -43.2089,
    municipiosAtendidos: 'Três Rios e Centro-Sul Fluminense'
  },
  // === REGIÃO DOS LAGOS ===
  {
    id: 220,
    nome: 'Hospital São José Operário',
    endereco: 'R. Gov. Valadares, s/n — São Cristóvão',
    cidade: 'Cabo Frio',
    regiao: 'Região dos Lagos',
    telefone: '(22) 2645-4084',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8789, lng: -42.0186,
    municipiosAtendidos: 'Cabo Frio, Búzios e Região dos Lagos'
  },
  {
    id: 221,
    nome: 'Hospital Municipal Pref. Armando Silva Carvalho',
    endereco: 'R. Eduardo Américo da Costa, s/n — São Vicente de Paulo',
    cidade: 'Araruama',
    regiao: 'Região dos Lagos',
    telefone: '(22) 2666-1238',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.8736, lng: -42.3428,
    municipiosAtendidos: 'Araruama e Região dos Lagos oeste'
  },
];
